"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theming = require("../../../theming");

var _themeContants = require("../../../constants/themeContants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Donut = function Donut(_ref) {
  var progress = _ref.progress,
      className = _ref.className,
      warningThreshold = _ref.warningThreshold,
      rest = _objectWithoutProperties(_ref, ["progress", "className", "warningThreshold"]);

  var dash = 57;
  var dashoffset = dash * progress - dash;
  return _react["default"].createElement(Wrapper, _extends({
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    className: className
  }, rest), _react["default"].createElement("title", null, progress * 100, "%"), _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: "6"
  }, _react["default"].createElement(Bg, {
    cx: "12",
    cy: "12",
    r: "9"
  }), _react["default"].createElement(Value, {
    cx: "12",
    cy: "12",
    r: "9",
    transform: "rotate(-90 12 12)",
    dash: dash,
    dashoffset: dashoffset,
    progress: progress,
    warningThreshold: warningThreshold
  })));
};

Donut.themeProps = {
  donut: {
    name: "donut",
    description: "Wrapper style for donut",
    type: _themeContants.themePropTypes.style
  },
  donutBackground: {
    name: "donut_bg",
    description: "Circle style for donut background",
    type: _themeContants.themePropTypes.style
  },
  donutValue: {
    name: "donut_value",
    description: "Value style for donut",
    type: _themeContants.themePropTypes.style
  }
};

var Wrapper = _styledComponents["default"].svg.withConfig({
  displayName: "Donut__Wrapper",
  componentId: "sc-11gzqbl-0"
})(["transform:rotateY(180deg);", ";"], (0, _theming.applyVariants)(Donut.themeProps.donut.name));

var Bg = _styledComponents["default"].circle.withConfig({
  displayName: "Donut__Bg",
  componentId: "sc-11gzqbl-1"
})(["stroke:", ";", ";"], _theming.color.line, (0, _theming.applyVariants)(Donut.themeProps.donutBackground.name));

var Value = _styledComponents["default"].circle.withConfig({
  displayName: "Donut__Value",
  componentId: "sc-11gzqbl-2"
})(["stroke:", ";stroke-dasharray:", ";stroke-dashoffset:", ";", ";"], function (p) {
  return p.progress >= p.warningThreshold ? _theming.color.warning : _theming.color.primary;
}, function (p) {
  return p.dash;
}, function (p) {
  return p.dashoffset;
}, (0, _theming.applyVariants)(Donut.themeProps.donutValue.name));

Donut.defaultProps = {
  className: "",
  warningThreshold: 0.9
};
Donut.propTypes = {
  progress: _propTypes["default"].number.isRequired,
  warningThreshold: _propTypes["default"].number,
  className: _propTypes["default"].string
};
var _default = Donut;
exports["default"] = _default;